import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import type { SelectProps } from 'antd';
import { Select } from 'antd';
import styled from 'styled-components';

const StyledSelect = styled((props: SelectProps) => <Select {...props} />)`
    &.ant-select {
        width: 100%;
        height: 46px;

        .ant-select-selector {
            span {
                ${DESKTOP_SIZES[SIZES.BODY_MD].fontSize}
            }
        }
    }
`;

export default StyledSelect;
